// extracted by mini-css-extract-plugin
module.exports = {"container":"FunctionsSection_container__1EceS","listWrapper":"FunctionsSection_listWrapper__2Swfu","buttonWrapper":"FunctionsSection_buttonWrapper__yndPe"};